export default __webpack_public_path__ + "static/media/kick_long.cc243b15.mp3";